/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_VOD_OUTPUTS',
  PUT: 'UPDATE_VOD_OUTPUTS',
  DELETE: 'DELETE_VOD_OUTPUTS',
  RESET: 'RESET_VOD_OUTPUTS',
  RELOAD: 'RELOAD_VOD_OUTPUTS',
};

export const getDraftId = () => (`vodOutputs-draft${new Date().valueOf()}`);

export const vodOutputsReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      return [
        ...state,
        { ...action.payload },
      ];
    case types.PUT:
      return action.payload;
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.indexOf(action.payload);
      newValues.splice(index, 1);
      return newValues;
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
